export const adsrStateTransitions = Object.freeze({
    attack: [`decay`, `release`],
    decay: [`sustain`, `release`],
    sustain: [`release`],
    release: [`complete`],
    complete: null,
});
